<template>
  <div>
    <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            
          </div>
        </div>
      </div>
    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ISBN</th>
                <th class="text-left">Title</th>
                <th class="text-left">Total No Of Copies</th>
                <th class="text-left">PO - No Of Copies</th>
                <!--<th class="text-left">NoOfLending</th>-->
                
                <th style="width: 0px"></th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="item in list" :key="item.id">
                <td>{{ item.ISBN }}</td>
                <td>{{ item.Title }}</td>
                <td>{{ item.Quantities }}</td>
                <td>{{ item.NoOfCopies }}</td>
                <!--<td>{{ item.NoOfLending }}</td>-->
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <Pagination :paging="paging" v-on:next="onNextPage" />
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";

export default {
  name: "CancelPurchaseOrderPublication",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  props: {
    //organizationId: { type: Number, required: true}
  },
  watch: {},
  created() {
    this.getPublicationByPagin(this.$route.params.id);
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin(this.$route.params.id);
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getPublicationByPagin(this.$route.params.id);
    },
    getPurchaseOrder(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("purchase-order", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.item = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(obj) {
      console.log(obj);
      this.$emit("onSelect", obj);
    },
    getPublicationByPagin(id) {
      this.list = [];

      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/cancel/po-publication/" + id + "/" + this.$route.params.organizationId, this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      Search: "",
      item: {},
      list: [],
      details: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC : false },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PO-Cancellation/CancelPurchaseOrderPublication.vue